import { render, staticRenderFns } from "./Block2Creation.vue?vue&type=template&id=2eadeb78&scoped=true&"
import script from "./Block2Creation.vue?vue&type=script&lang=js&"
export * from "./Block2Creation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eadeb78",
  null
  
)

export default component.exports